<div class="after-sales-tracker" *ngIf="hasPipeline; else noPipeline">

  <!-- ═══ STAGE CHEVRON BAR ═══ -->
  <div class="tracker-header">
    <div class="tracker-title">
      <span class="material-icons tracker-icon">local_shipping</span>
      <span>After-Sales Pipeline</span>
      <span class="pipeline-badge">{{ stageList.length }} Stages</span>
    </div>
    <button class="history-btn" (click)="toggleHistory()">
      <span class="material-icons">history</span>
      View History
    </button>
  </div>

  <div class="stage-bar-scroll">
    <div class="stage-bar">
      <div
        *ngFor="let stage of stageList; let i = index"
        class="stage-chevron"
        [class.stage-done]="i < currentStageIndex"
        [class.stage-active]="i === currentStageIndex"
        [class.stage-pending]="i > currentStageIndex"
        [attr.title]="stage.statusName">
        <span class="chevron-label">{{ stage.statusName }}</span>
        <span class="material-icons chevron-check" *ngIf="i < currentStageIndex">check</span>
      </div>
    </div>
  </div>

  <!-- ═══ CURRENT STAGE INFO CARD ═══ -->
  <div class="stage-info-card" *ngIf="currentStage">
    <div class="stage-info-grid">
      <div class="info-cell">
        <span class="info-label">Current Stage</span>
        <span class="info-value stage-name-value">{{ entityObject.afterSalesStatus || currentStage.statusName }}</span>
      </div>
      <div class="info-cell">
        <span class="info-label">Started On</span>
        <span class="info-value">{{ entityObject.afterSalesStartedDate | date:'dd MMM yyyy' }}</span>
      </div>
      <div class="info-cell">
        <span class="info-label">Status</span>
        <span class="info-badge" [class.badge-active]="!entityObject.afterSalesCompletedDate"
              [class.badge-done]="entityObject.afterSalesCompletedDate">
          {{ entityObject.afterSalesCompletedDate ? 'Completed' : (currentSubStatusIndex >= 0 ? subStatusList[currentSubStatusIndex]?.statusName : 'In Progress') }}
        </span>
      </div>
    </div>
  </div>

  <!-- ═══ MANUAL ADVANCE BUTTON (NO SUB-STATUS OR FINAL SUB-STATUS COMPLETED) ═══ -->
  <div class="substatus-section no-substatus-stage" *ngIf="(subStatusList.length === 0 || currentSubStatusIndex === subStatusList.length - 1) && currentStageIndex !== -1 && currentStageIndex < stageList.length - 1">
    <div class="substatus-header">
      <span class="substatus-title">
        <span class="material-icons">track_changes</span>
        {{ currentStage?.statusName }} — {{ subStatusList.length === 0 ? 'No Sub-Tasks Configured' : 'Ready to Advance' }}
      </span>
      <button class="update-btn advance-btn" style="background-color: #3f51b5; color: white; border: none;" mat-stroked-button (click)="advanceToNextStageManually()" [disabled]="isUpdating">
        <span class="material-icons">arrow_forward</span>
        Move to Next Stage
      </button>
    </div>
    <div style="padding: 16px 0; color: #888; font-size: 13px; text-align: center;">
      <span class="material-icons" style="vertical-align: middle; font-size: 18px; margin-right: 4px; color: #aaa;">info_outline</span>
      {{ subStatusList.length === 0 ? 'This stage has no sub-tasks. Click "Move to Next Stage" to advance.' : 'All sub-tasks are completed. Click "Move to Next Stage" to advance.' }}
    </div>
  </div>

  <!-- ═══ SUB-STATUS PROGRESS ═══ -->
  <div class="substatus-section" *ngIf="subStatusList.length > 0">


    <div class="substatus-header">
      <span class="substatus-title">
        <span class="material-icons">track_changes</span>
        {{ currentStage?.statusName }} Progress (Sub Status)
      </span>
      <button class="update-btn" mat-stroked-button (click)="toggleHistory()">
        <span class="material-icons">update</span>
        Update Status
      </button>
    </div>

    <div class="substatus-track-wrap">
      <div class="substatus-track">
        <div class="track-line">
          <div class="track-fill"
            [style.width]="(currentSubStatusIndex >= 0 ? (currentSubStatusIndex / (subStatusList.length - 1)) * 100 : 0) + '%'">
          </div>
        </div>
        <div class="substatus-steps">
          <div
            *ngFor="let sub of subStatusList; let j = index"
            class="substatus-step"
            [class.step-done]="j < currentSubStatusIndex"
            [class.step-active]="j === currentSubStatusIndex"
            [class.step-pending]="j > currentSubStatusIndex"
            (click)="selectSubStatus(sub, j)"
            [title]="sub.statusName">
            <div class="step-dot">
              <span class="material-icons step-icon" *ngIf="j < currentSubStatusIndex">check</span>
              <span class="step-number" *ngIf="j >= currentSubStatusIndex">{{ j + 1 }}</span>
            </div>
            <div class="step-label">{{ sub.statusName }}</div>
            <div class="step-date" *ngIf="j === currentSubStatusIndex && entityObject.afterSalesStartedDate">
              {{ entityObject.afterSalesStartedDate | date:'dd MMM yyyy' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ HISTORY PANEL ═══ -->
  <div class="history-panel" *ngIf="showHistory">
    <div class="history-header">
      <span class="material-icons">history</span> Sub-Status Change History
    </div>
    <div *ngIf="historyList.length === 0" class="history-empty">No history found.</div>
    <div class="history-list" *ngIf="historyList.length > 0">
      <div class="history-item" *ngFor="let h of historyList">
        <div class="history-dot"></div>
        <div class="history-content">
          <span class="history-main">Changed to <strong>{{ h.toSubStatusName }}</strong></span>
          <span class="history-sub" *ngIf="h.changedByName">by {{ h.changedByName }}</span>
          <span class="history-date">{{ h.changedAt | date:'dd MMM yyyy, hh:mm a' }}</span>
          <div class="history-note" *ngIf="h.notes">
            <span class="material-icons note-icon" style="font-size: 14px; vertical-align: middle;">sticky_note_2</span>
            <span style="font-style: italic; color: #666; font-size: 12px; margin-left: 4px;">{{ h.notes }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- ═══ NO PIPELINE PLACEHOLDER ═══ -->
<ng-template #noPipeline>
  <div class="no-pipeline-placeholder">
    <div class="no-pipeline-icon-wrap">
      <span class="material-icons no-pipeline-icon">account_tree</span>
    </div>
    <div class="no-pipeline-text">
      <span class="no-pipeline-title">No After-Sales Pipeline Configured</span>
      <span class="no-pipeline-hint">
        Go to <strong>Deal Stages</strong> and associate a pipeline with the
        <em>{{ entityObject?.statusName || entityObject?.stage || 'current' }}</em> stage.
      </span>
    </div>
  </div>
</ng-template>
